export default "__VITE_ASSET__8e6ab21d__"